import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './LinearProgress.module.less';

function LinearProgress(props) {
  const {
    color = 'primary',
    value = null,
    valueBuffer = null,
    variant = 'indeterminate',
    className,
    ...other
  } = props;

  const rootProps = {};
  const bar1Styles = {};
  const bar2Styles = {};

  if (variant === 'determinate' || variant === 'buffer') {
    if (value != null) {
      rootProps['aria-valuenow'] = Math.round(value);
      let transform = value - 100;
      bar1Styles.transform = `translateX(${transform}%)`;
    } else {
      console.error(
        'LinearProgress: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .'
      );
    }
  }
  if (variant === 'buffer') {
    if (valueBuffer != null) {
      let transform = (valueBuffer || 0) - 100;
      bar2Styles.transform = `translateX(${transform}%)`;
    } else {
      console.error(
        'LinearProgress: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.'
      );
    }
  }

  return (
    <div
      className={clsx(
        styles.LinearProgress,
        styles[color],
        styles[variant],
        className
      )}
      role="progressbar"
      {...rootProps}
      {...other}
    >
      {variant === 'buffer' ? <div className={styles.dashed} /> : null}
      <div className={clsx(styles.bar, styles.bar1)} style={bar1Styles} />
      {variant === 'determinate' ? null : (
        <div className={clsx(styles.bar, styles.bar2)} style={bar2Styles} />
      )}
    </div>
  );
}

LinearProgress.displayName = 'LinearProgress';
LinearProgress.propTypes = {
  /** The color of the component. */
  color: PropTypes.oneOf(['primary', 'secondary', 'brand']),
  /** The value of the progress indicator for the determinate and buffer variants. Value between 0 and 100. */
  value: PropTypes.number,
  /** The value for the buffer variant. Value between 0 and 100. */
  valueBuffer: PropTypes.number,
  /** The variant to use. Use indeterminate or query when there is no progress value. */
  variant: PropTypes.oneOf(['indeterminate', 'determinate', 'buffer', 'query']),
  className: PropTypes.string,
};

export default LinearProgress;
